import coverImg from "assets/images/v153/bg.webp"
import pictureImg from "assets/images/v153/cover.webp"
import titleImg from "assets/images/v153/title.webp"

export const v153Config = {
  cover: { en: coverImg },
  title: { en: titleImg },
  picture: pictureImg,
}
